import axios from 'axios';

const BASE_API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
const API_URL = `${BASE_API_URL}/api/v1`;

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// --- متغیرهای مدیریت صف رفرش ---
let isRefreshing = false;
let failedQueue = [];
let isRedirecting = false;   // 🆕 جلوگیری از ریدایرکت‌های تکراری

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    error ? prom.reject(error) : prom.resolve(token);
  });
  failedQueue = [];
};

// --- مسیرهای عمومی که نیاز به توکن ندارند ---
const publicPaths = [
  '/auth/register',
  '/auth/login',
  '/auth/token/refresh',
  '/token/refresh',
  '/auth/password-reset/request',
  '/auth/password-reset/confirm',
  '/products/categories',
  '/products/main-categories',
  '/products/latest',
  '/products/list',
  '/products/search',
  '/products/tags',
  '/books',
  '/profile/daily-message',
  '/health',
];

// --- Interceptor درخواست ---
apiClient.interceptors.request.use((config) => {
  const urlPath = (config.url || '').replace(/^\//, '');
  const isPublic = publicPaths.some(path => {
    const cleanPath = path.replace(/^\//, '');
    return urlPath === cleanPath || urlPath.startsWith(cleanPath + '/');
  });

  if (!isPublic) {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
  }

  console.log('📡 REQUEST:', config.method?.toUpperCase(), config.url,
    'Token:', config.headers?.Authorization ? 'YES' : 'NO');
  return config;
}, error => Promise.reject(error));

// --- Interceptor پاسخ ---
apiClient.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      // اگر درخواست اصلی خودش refresh بود، دیگر تلاش نکن
      if (originalRequest.url.includes('/token/refresh/')) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        if (!isRedirecting && window.location.pathname !== '/login') {
          isRedirecting = true;
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) {
          // بدون refresh token نمی‌توان کاری کرد
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          if (!isRedirecting && window.location.pathname !== '/login') {
            isRedirecting = true;
            window.location.href = '/login';
          }
          isRefreshing = false;
          return Promise.reject(error);
        }

        try {
          let res;
          try {
            res = await axios.post(`${API_URL}/auth/token/refresh/`, { refresh: refreshToken });
          } catch {
            res = await axios.post(`${API_URL}/token/refresh/`, { refresh: refreshToken });
          }
          const newAccess = res.data.access;
          localStorage.setItem('access_token', newAccess);
          // اگر رفرش توکن جدید هم داد (با توجه به ROTATE_REFRESH_TOKENS=True)
          if (res.data.refresh) {
            localStorage.setItem('refresh_token', res.data.refresh);
          }

          originalRequest.headers['Authorization'] = `Bearer ${newAccess}`;
          processQueue(null, newAccess);
          isRefreshing = false;
          return apiClient(originalRequest);
        } catch (refreshError) {
          // رفرش ناموفق – خروج کامل
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          processQueue(refreshError, null);
          isRefreshing = false;
          if (!isRedirecting && window.location.pathname !== '/login') {
            isRedirecting = true;
            window.location.href = '/login';
          }
          return Promise.reject(refreshError);
        }
      }

      // اگر رفرش در حال انجام است، درخواست را در صف بگذاریم
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(token => {
        originalRequest.headers['Authorization'] = `Bearer ${token}`;
        return apiClient(originalRequest);
      }).catch(err => Promise.reject(err));
    }

    return Promise.reject(error);
  }
);

export default apiClient;